var _g, _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AddCardIcon_svg__clip0_15243_104472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.721 4.935h15.785c.396 0 .718.321.718.718v11.48a.718.718 0 01-.718.717H.721a.718.718 0 01-.717-.718V5.652c0-.396.321-.717.717-.717zm15.068 5.74H1.439v5.74h14.35v-5.74zm0-1.435V6.37H1.439v2.87h14.35zM3.352 13.545h2.87v1.435h-2.87v-1.435z",
    fill: "#000"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.259,
    cy: 8.522,
    r: 6.74,
    fill: "#E95832",
    stroke: "#fff",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.857 8.123V5.731h.797v2.392h2.391v.797h-2.391v2.392h-.797V8.92h-2.392v-.797h2.392z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AddCardIcon_svg__clip0_15243_104472"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 2.783)",
    d: "M0 0h17.22v17.22H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/AddCardIcon.a48ed4b0.svg";
export { SvgAddCardIcon as ReactComponent };